import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const DudasSugerencias = props => <ServerComponentCaller url={"assets/data/pages/dudasSugerencias.json"}/>


export default DudasSugerencias;